// src/components/Footer.jsx
// Slim cross-link tying this X20 product site back to the X20 Consulting hub.
import React from "react";
import { withTheme } from "../theming";

const Footer = ({ theme }) => {
  const accent = (theme && theme.accentColor) || "#7e9aae";
  const bg = (theme && theme.backgroundColor) || "#10202c";
  const text = (theme && theme.textColor) || "#ffffff";
  return (
    <footer
      style={{
        backgroundColor: bg,
        color: text,
        borderTop: `1px solid ${accent}22`,
        padding: "22px 16px",
        textAlign: "center",
      }}
    >
      <a
        href="https://x20-consulting.com"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color: accent,
          fontWeight: 600,
          textDecoration: "none",
          fontSize: "0.95rem",
          transition: "opacity 0.2s ease",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.85")}
        onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
      >
        Part of the X20 Consulting family →
      </a>
    </footer>
  );
};

export default withTheme(Footer);
